import { ItemFamily } from '../types';

export type BasketCompartment = 'halloween' | 'christmas';

export function isCorrectCatch(family: ItemFamily, compartment: BasketCompartment): boolean {
  if (family === ItemFamily.Fusion) return true;
  return family === ItemFamily.Halloween ? compartment === 'halloween' : compartment === 'christmas';
}

export function scoreCatch(basePoints: number, combo: number): number {
  const comboMultiplier = 1 + Math.min(Math.max(combo - 1, 0), 5) * 0.1;
  return Math.round(basePoints * comboMultiplier);
}

export function calculateStars(score: number, [one, two, three]: [number, number, number]): number {
  if (score >= three) return 3;
  if (score >= two) return 2;
  if (score >= one) return 1;
  return 0;
}

export function isLevelPassed(stars: number): boolean {
  return stars > 0;
}
